module.exports = __webpack_public_path__ + "media/images/lb/513-85218d5c0d1a390faaf1038ea34064b7.svg";